import useBranchId from "@/shared/hooks/useBranchId";
import { withCloudinaryBackgroundRemoval } from "@/shared/utils/helpers";
import { preloadImages } from "@/shared/utils/preloadImages";
import { Menu } from "@/shared/v2/queries/interfacesV2";
import { useEffect, useMemo } from "react";
import {
  resolveToppingImageUrl,
  toppingCategoryHasImage,
} from "./kioskImageUtils";

/** Preload product + topping images for every category in a menu. */
const usePreloadKioskCategoryImages = (menu?: Menu | null) => {
  const branch = useBranchId();

  const urls = useMemo(() => {
    if (!menu?.navigation_content?.length) return [];

    const collected: string[] = [];
    menu.navigation_content.forEach((category) => {
      category.sub_content?.forEach((product) => {
        if (product.image_cloudinary_id) {
          const introImage = withCloudinaryBackgroundRemoval(
            product.image_cloudinary_id
          );
          if (introImage) collected.push(introImage);
        }

        product.sub_content?.forEach((garnish) => {
          if (!toppingCategoryHasImage(garnish.item_image_and_text_properties)) {
            return;
          }

          garnish.sub_content?.forEach((topping) => {
            const toppingImage = resolveToppingImageUrl(
              topping.image_cloudinary_id,
              branch
            );
            if (toppingImage) collected.push(toppingImage);
          });
        });
      });
    });
    return [...new Set(collected)];
  }, [menu?.navigation_content, branch]);

  useEffect(() => {
    if (urls.length > 0) {
      preloadImages(urls);
    }
  }, [urls]);
};

export default usePreloadKioskCategoryImages;
